import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { withConfig } from 'src/withConfig';

/* 1 - You can delete this if z-index will be deleted in Selection component */
export const MoreLessGroup = withConfig(theme => styled('div', { label: 'MoreLessGroup' })`
    background-color: ${theme.star.heroEvents.bgColorTertiary};
    border-top: solid 1px ${theme.star.heroEvents.borderColorTertiary};
    padding: 8px 10px 7px;
    text-align: center;
    position: relative;
    margin-top: -1px;
    cursor: pointer;
`);

interface LinkMoreLessWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setLinkMoreLessWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            &:hover {
                background: ${theme.star.moreLessButton.bgColorSecondary};
                color: ${theme.star.moreLessButton.txtColorSecondary};
            }
        `;
    }
    return css``;
};

export const LinkMoreLessWrapper = withConfig(theme => styled('div', { label: 'LinkMoreLessWrapper' })<LinkMoreLessWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setLinkMoreLessWrapper(variant, theme)};
    background-color: transparent;
    border: 0;
    color: ${theme.star.heroSingleMarket.txtColor};
    font-weight: ${theme.star.fontWeight.bold};
    display: inline-block;
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4;
    padding: 0 18px 2px 10px;
    position: relative;
    text-decoration: none;
`);

export const ChevronIconStyle = styled(ChevronIcon, { label: 'ChevronIconStyle' })`
    fill: currentcolor;
    flex: 0 0 12px;
    margin: 0 8px;
    width: 12px;
`;
